import React from 'react';
import { AuditLogTitle, DashboardTitle, DefaultDashboardTitle } from '../../../Utils/Constants';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import { Container, Row , Col} from 'reactstrap';
import DashboardTokencounts from '../../../Utils/CommonComponents/CommonDashboard/CommonDefault/DashboardTokencounts';
import JobCard from './JobCard';

export default function DefaultDashboard() {
    return (
        <>
            <div style={{ backgroundColor: 'white', minHeight: '100vh', width: '100vw' }}>
                <Breadcrumbs
                    pageTitle={DefaultDashboardTitle}
                    parent={DashboardTitle}
                    title={DefaultDashboardTitle}
                />
                <Container fluid className="px-3">
                    <Row className="mx-0">
                        <Col md={9} lg={10} className="px-3">
                            <DashboardTokencounts />
                        </Col>
                    </Row>

                </Container>
            </div>
        </>
    );
}

